import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

// import { flat } from "@utils";
import { protectedRoutes } from "app/routes";

import GullLayout from "app/layouts/GullLayout";
// import AccessDenied from "app/views/sessions/AccessDenied";


const userHasPermission = (pathname, user, routes) => {
  if (!user) {
    return false;
  }

  const matched = routes.find((r) => r.path === pathname);
  // console.log(matched, "matched");
  
  return matched && matched.auth && matched.auth.length ? matched.auth.includes(user.role) : true;
  };

export default function AuthGuard() {

  // const { pathname } = useLocation();
  // const [previousRoute, setPreviousRoute] = useState(null);
  // const { isAuthenticated, user } = useSelector((state) => state.auth);
  // let hasPermission = userHasPermission(pathname, user, protectedRoutes);

  // useEffect(() => {
  //   if (previousRoute !== null) setPreviousRoute(pathname);
  // }, [pathname, previousRoute]);

  const location = useLocation();
  
  // Get authentication state from Redux store
  const { user } = useSelector((state) => state.auth);
  // console.log(user, "user");
  
  // Check token in localStorage (fallback for authentication)
  const isAuthenticated = localStorage.getItem("sessionActive") === "true";
  
  userHasPermission(location.pathname, user, protectedRoutes);

  if (!isAuthenticated) {
    // Redirect to login if user is not authenticated
    return <Navigate to="/sessions/signin" replace={true} />;
  }

  // if (!hasPermission) {
  //   // Show Access Denied if user lacks permission
  //   return <AccessDenied />;
  // }


  return (
    <>
      {isAuthenticated ? (
        <GullLayout>
          <Outlet />
        </GullLayout>
      ) : (
        <GullLayout>
          <Outlet />
        </GullLayout>
      )}
    </>
  );

  // return (
  //   <>
  //     {isAuthenticated && hasPermission ? (
  //       <GullLayout>
  //         <Outlet />
  //       </GullLayout>
  //     ) : (
  //       <>
  //         {isAuthenticated && !hasPermission ? (
  //           <AccessDenied />
  //         ) : (
  //           <Navigate to={previousRoute || "/sessions/signin"} replace={true} />
  //         )}
  //       </>
  //     )}
  //   </>
  // );
}
